<template>
  <div class="sky__content-page py-10">
    <div class="mx-auto" style="width: 900px; max-width: 100%;" v-html="bodyContent" />
  </div>
</template>

<script>
import { marked } from 'marked'

export default {
  async asyncData ({ app, route, error, redirect }) {
    try {
      const { data } = await app.$api.get('/content', {
        params: {
          slug: route.params.slug
        }
      })

      return {
        content: data
      }
    } catch (e) {
      if (e?.response?.status === 404) {
        try {
          let path = route.path
          const hasTrailingSlash = path.match(/\/$/)

          if (hasTrailingSlash) {
            path = path.slice(0, -1)
          }
          const redirection = await app.$api.post('/redirections', {
            path
          })
          if (redirection.data.redirect) {
            redirect(301, redirection.data.redirect + (hasTrailingSlash ? '/' : ''))
            return
          }
        } catch (e) {
          app.$gtmEvents.onRuntimeError(e, 'resolve/redirection')
        }

        error({ statusCode: 404, message: e.response.data })
      } else {
        error({ statusCode: 500, message: e?.message })
      }
    }
  },
  head () {
    return {
      title: this.content.attributes.name,
      meta: this.content.attributes.meta_description
        ? [
            {
              hid: 'description',
              name: 'description',
              content: this.content.attributes.meta_description
            }
          ]
        : undefined
    }
  },
  computed: {
    bodyContent () {
      return marked(this.content.attributes.content)
    }
  },
  mounted () {
    this.$gtmEvents.onRegularPageView()
  }
}
</script>

<style lang="scss">
  .sky__content-page {
    h1 {
      @apply text-2xl mb-3 font-bold;
    }
    h2 {
      @apply text-xl mb-2 font-bold
    }
    p {
      @apply mb-3;
    }
  }
</style>
